import { DropdownMenuItem } from "../components/DocumentParserTableButton";

export const DOCUMENT_PARSER_CONSTANTS = {
  INDEX_PAGE_CONTENT: {
    PAGE_HEADER: "Document Parser",
    TABLE: {},
    UTILS: {
      DOCUMENTS: "Document",
    },
  },
  XERO_TENANT_CHANGES: {
    TOOLTIP_TRIGGER_CONTENT: "Tax Rate & Account Updated",
    TOOLTIP_CONTENT:
      "Some tax rates and accounts have been updated after reconnecting to Xero. Please review your selections to ensure the correct tax rate and account are applied to each record.",
  },
};

export const AMOUNT_ARE_ENUM = {
  INCLUSIVE: "INCLUSIVE",
  EXCLUSIVE: "EXCLUSIVE",
  NO_TAX: "NO_TAX",
  NOT_SELECTED: "NOT_SELECTED",
};

export const AMOUNTS_ARE_OPTIONS = [
  { label: "Inclusive (Include Tax)", value: AMOUNT_ARE_ENUM.INCLUSIVE },
  { label: "Exclusive (Exclude Tax)", value: AMOUNT_ARE_ENUM.EXCLUSIVE },
  { label: "No Tax (Tax Not Applied)", value: AMOUNT_ARE_ENUM.NO_TAX },
];

export enum DocumentType {
  NOT_SELECTED = "NOT_SELECTED",
  INVOICES = "INVOICE",
  BILLS_TO_PAY = "BILLS_TO_PAY",
}

export enum DocumentTypeLabel {
  INVOICES = "Invoices (Credit)",
  BILLS_TO_PAY = "Bills to Pay (Debit)",
}

export const ACCOUNT_TYPE_OPTIONS = [
  {
    label: DocumentTypeLabel.BILLS_TO_PAY,
    value: DocumentType.BILLS_TO_PAY,
  },
  { label: DocumentTypeLabel.INVOICES, value: DocumentType.INVOICES },
];

export enum ProcessingStatus {
  PENDING = "PENDING",
  UPLOADING = "UPLOADING",
  UPLOADED = "UPLOADED",
  EXTRACTING = "EXTRACTING",
  EXTRACTED = "EXTRACTED",
  PROCESSING_AI = "PROCESSING_AI",
  COMPLETED = "COMPLETED",
  DUPLICATE = "DUPLICATE",
  FAILED = "FAILED",
  UN_SUPPORTED_FORMAT = "UN_SUPPORTED_FORMAT",
  REQUEUED_EXTRACT = "REQUEUED_EXTRACT",
  REQUEUED_AI = "REQUEUED_AI",
  CANCELLED = "CANCELLED",
  LARGE_FILE = "LARGE_FILE",
}

export const PARSER_PROGRESS = {
  PENDING: 0,
  UPLOADING: 10,
  UPLOADED: 20,
  EXTRACTING: 30,
  EXTRACTED: 50,
  PROCESSING_AI: 70,
  COMPLETED: 100,
  FAILED: 0,
  DUPLICATE: 0,
  UN_SUPPORTED_FORMAT: 0,
  REQUEUED_EXTRACT: 0,
  REQUEUED_AI: 0,
  CANCELLED: 0,
  LARGE_FILE: 0,
};

export const rowStyles: Record<
  ProcessingStatus,
  { bg: string; label: string; color: string; border: string }
> = {
  [ProcessingStatus.PENDING]: {
    bg: "bg-gray-100",
    label: "Waiting...",
    color: "text-gray-500",
    border: "border-gray-200",
  },
  [ProcessingStatus.UPLOADING]: {
    bg: "bg-blue-100",
    label: "Uploading...",
    color: "text-blue-500",
    border: "border-blue-200",
  },
  [ProcessingStatus.UPLOADED]: {
    bg: "bg-sky-100",
    label: "Uploaded",
    color: "text-sky-500",
    border: "border-sky-200",
  },
  [ProcessingStatus.EXTRACTING]: {
    bg: "bg-yellow-100",
    label: "Extracting...",
    color: "text-yellow-500",
    border: "border-yellow-200",
  },
  [ProcessingStatus.EXTRACTED]: {
    bg: "bg-cyan-100",
    label: "Extracted",
    color: "text-cyan-500",
    border: "border-cyan-200",
  },
  [ProcessingStatus.PROCESSING_AI]: {
    bg: "bg-purple-100",
    label: "AI processing...",
    color: "text-purple-500",
    border: "border-purple-200",
  },
  [ProcessingStatus.COMPLETED]: {
    bg: "bg-green-100",
    label: "Completed",
    color: "text-green-500",
    border: "border-green-200",
  },
  [ProcessingStatus.DUPLICATE]: {
    bg: "bg-amber-100",
    label: "Duplicate",
    color: "text-amber-500",
    border: "border-amber-200",
  },
  [ProcessingStatus.FAILED]: {
    bg: "bg-red-100",
    label: "Failed",
    color: "text-red-500",
    border: "border-red-200",
  },
  [ProcessingStatus.UN_SUPPORTED_FORMAT]: {
    bg: "bg-orange-100",
    label: "Unsupported",
    color: "text-orange-500",
    border: "border-orange-200",
  },
  [ProcessingStatus.REQUEUED_EXTRACT]: {
    bg: "bg-blue-100",
    label: "Requeued Extract",
    color: "text-blue-500",
    border: "border-blue-200",
  },
  [ProcessingStatus.REQUEUED_AI]: {
    bg: "bg-green-100",
    label: "Requeued AI",
    color: "text-green-500",
    border: "border-green-200",
  },
  [ProcessingStatus.CANCELLED]: {
    bg: "bg-gray-100",
    label: "Cancelled",
    color: "text-gray-500",
    border: "border-gray-200",
  },
  [ProcessingStatus.LARGE_FILE]: {
    bg: "bg-red-100",
    label: "Large File",
    color: "text-red-500",
    border: "border-red-200",
  },
};

export enum IntelliBillStatus {
  DRAFT = "DRAFT",
  XERO_READY = "XERO_READY",
  SENT_TO_XERO = "SENT_TO_XERO",
}

export const DOCUMENT_PARSER_TOAST_MESSAGES = {
  TABLE_UPDATED: "Document parser table updated",
  ROW_PROCESS_NOT_COMPLETED:
    "This document isn't ready for comparison yet. Retry or contact support.",
  FAILED_TO_PROCESS_DOCUMENT:
    "Failed to process document. Reupload the document again.",
  XERO_READY: "Invoice saved as xero ready successfully.",
  SENT_TO_XERO: "Invoice sent to Xero successfully.",
  INVOICE_UPDATED: "Invoice details updated successfully.",
  XERO_SYNC_STARTED:
    "Xero Data Sync Started. We will notify you once it is completed.",
  XERO_SYNCED: "Xero Data Synced Successfully",
  XERO_SYNC_ERROR: "Xero Data Sync Failed. Please try again later.",
  DOCUMENT_LINE_ITEMS_REQUIRED: "At least one line item is required.",
  DOCUMENT_RETRIED:
    "Document has been successfully sent for re-processing. We will notify you once it is completed.",
  RE_PROCESS_DOC_COMPLETED:
    "Your re-processed document is ready for comparison.",
  AI_REFETCH_TRIGGERED: "AI re-fetch has been triggered successfully.",
  DOCUMENT_EXTRACTION_FAILED:
    "Document Creation hasn't been completed. Retry or contact support.",
  ALREADY_IN_RETRY: "Document is already in retry",
  WORKSPACE_NOT_CONNECTED_WITH_XERO: "Workspace is not connected with Xero.",
};

export const CONSENT_MESSAGE = {
  TITLE: "Unsaved Changes",
  DESCRIPTION:
    "You have unsaved edits. Save your work before leaving to avoid losing your changes.",
  BUTTON_NAME: "Cancel",
  CANCEL_NAME: "Go Back",
};

export enum SAVE_ID {
  draft = "draft",
  xeroReady = "xero-ready",
}

export enum OTHER_ITEM_ID {
  sync = "sync",
  delete = "delete",
}

export enum REFETCH_AI_ID {
  lineItemsRecheck = "line-items-recheck",
}

export const documentParserApiRoutes = {
  upload: "/workspace/:workspace/intelliflow/upload",
  uploadedDocs: "/workspace/:workspace/intelliflow",
  triggerNextStep: "/workspace/:workspace/intelliflow/:id/trigger-next-step",
  billById: "/workspace/:workspace/intelliflow/bills/:id",
  singleDocById: "/workspace/:workspace/intelliflow/:id",
  billLineItemById: "/workspace/:workspace/intelliflow/bills/line-item/:id",
  billStatusById: "/workspace/:workspace/intelliflow/bills/:id/status",
  refetchAiById: "/workspace/:workspace/intelliflow/:id/refetch-ai",
};

export const SAVE_DROPDOWN_ITEMS: DropdownMenuItem[] = [
  {
    id: SAVE_ID.xeroReady,
    label: "Save as Xero-Ready",
    buttonVariant: {
      variant: "outline",
    },
  },
  {
    id: SAVE_ID.draft,
    label: "Save Changes",
    buttonVariant: {
      variant: "default",
    },
  },
];

export const GENERIC_WORD_CONSTANTS = [
  "the",
  "a",
  "an",
  "shop",
  "store",
  "company",
  "co",
  "corp",
  "corporation",
  "inc",
  "incorporated",
  "ltd",
  "limited",
  "llc",
  "group",
  "enterprises",
  "enterprise",
  "business",
  "services",
  "service",
  "solutions",
  "systems",
  "partners",
  "associates",
  "best",
  "top",
  "premier",
  "first",
  "main",
  "central",
  "local",
  "regional",
  "national",
  "international",
  "global",
  "world",
  "super",
  "mega",
  "big",
  "small",
  "family",
  "royal",
  "golden",
  "silver",
  "new",
  "old",
  "modern",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
];
